module.exports = __webpack_public_path__ + "img/signin_company.6590b0f9.svg";